// extracted by mini-css-extract-plugin
export default {"profilePopoverCard":"view-profile-popover-skeleton_profilePopoverCard__15pka"};